const STORAGE_KEY = 'kgr:child:times:sort';

const list = document.getElementById('childTimesList');
const indicator = document.getElementById('sortIndicator');

if (list && indicator) {
    const getDirection = () => localStorage.getItem(STORAGE_KEY) || 'desc';

    const isNewEntry = (row) => {
        if (!row.id || !row.id.startsWith('row_')) return true;
        return !parseInt(row.id.replace('row_', ''), 10);
    };

    const sortRows = (direction) => {
        const rows = [...list.querySelectorAll('tr')];
        const newEntries = [];
        const existingEntries = [];

        for (const row of rows) {
            row.remove();
            if (isNewEntry(row)) {
                newEntries.push(row);
            } else {
                existingEntries.push(row);
            }
        }

        existingEntries.sort((a, b) => {
            const dateA = a.getAttribute('data-filter-dateFrom') || '';
            const dateB = b.getAttribute('data-filter-dateFrom') || '';

            if (dateA === dateB) {
                const endA = a.getAttribute('data-filter-dateTo') || '';
                const endB = b.getAttribute('data-filter-dateTo') || '';
                return direction === 'desc' ? endB.localeCompare(endA) : endA.localeCompare(endB);
            }

            return direction === 'desc' ? dateB.localeCompare(dateA) : dateA.localeCompare(dateB);
        });

        for (const row of newEntries) list.appendChild(row);
        for (const row of existingEntries) list.appendChild(row);

        indicator.textContent = direction === 'desc' ? '▼' : '▲';
    };

    document.getElementById('sortByStart').addEventListener('click', (e) => {
        e.stopPropagation();
        const next = getDirection() === 'desc' ? 'asc' : 'desc';
        localStorage.setItem(STORAGE_KEY, next);
        sortRows(next);
    });

    const direction = getDirection();
    if (direction === 'asc') {
        sortRows('asc');
    }
}
